const doc = [({"en":({"js":({"admin":({"tenant_domains":({"row":({"select_layout":"Select layout"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;